import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const MAP_SELECTOR = '.locator-map__google-map'

const MAP_STYLE = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]

const MAP_OPTIONS = {
  selectors: {
    form: '.mlmi-locator-form',
    list: '.locations-list',
    where: 'input[name="where"]',
    radius: 'select[name="radius"]',
    limit: 'select[name="limit"]',
  },
  basicOptions: {
    zoom: 10,
    maxZoom: 18,
    minZoom: 4,
    lat: 45.60495258760901,
    lng: -73.71906734960938,
    mapStyle: MAP_STYLE,
    autoFadeIn: true,
    autoFitBounds: true,
    autoSubmitSearch: false,
    enableGeolocation: false,
    enablePositionMarker: true,
    searchAfterGeolocation: false,
    putSearchParametersInURL: false,
    enabledCountries: ['ca', 'us'],
    autoCompleteOptions: {
      types: ['geocode'] ,
    },
  },
  clusterOptions: {
    useClusters: false,
  },
  bubbleOptions: {
    useBubbles: false,
  },
  getMarkerIcon: function(location) {
    let markerIcon = {
      url: '/img/elements/map-marker-beige.png',
      width: 64 * 3/4,
      height: 89 * 3/4,
      anchorX: 64 / 2 * 3/4,
      anchorY: 89 * 3/4,
      scaledWidth: 64 * 3/4,
      scaledHeight: 89 * 3/4,
    }
    if (location.filters.includes('salle-de-montre')) {
      markerIcon.url = '/img/elements/map-marker-black.png'
    }
    return markerIcon
  },
  filterBounds: function(bounds) {
    return bounds
  },
}

let self

$.fn.LocationItem = function() {
  let item = this

  if (item.data('location-item')) {
    return item.data('location-item')
  }

  item.close = function() {
    if (item.hasClass('--opened')) {
      item.removeClass('--opened')
      item.find('.location-item__form').slideUp(400, 'easeInOutQuart', function() {
        item.find('.location-item__call-cta').fadeOut(200, function() {
          item.find('.location-item__form-cta').fadeIn(200)
        })
      })
    }
  }

  item.open = function() {
    if (!item.hasClass('--opened')) {
      item.addClass('--opened')
      item.find('.location-item__form-cta').fadeOut(200, function() {
        item.find('.location-item__call-cta').fadeIn(200)
      })
      item.initialize_form()
      item.find('.location-item__form').slideDown(800, 'easeInOutQuart', function() {
        ScrollTrigger.refresh()
      })
    }
  }

  item.initialize_form = function() {
    item.find('.retailer-form').each(function() {
      $(this).RetailerForm()
    })
  }

  item.clicked = function(forceScroll) {
    if (item.hasClass('--opened')){
      return false;
    }
    if (forceScroll == undefined) {
      forceScroll = false
    }
    let openedItems = $('.location-item.--opened')
    if (openedItems.length) {
      openedItems.each(function() {
        $(this).LocationItem().close()
      })
      setTimeout(function() {
        let targetTop = item.offset().top
        targetTop -= $('.header').outerHeight(false) + ($.mlmi.mobile.isMobile ? 18 : 24)
        if (targetTop < $(window).scrollTop() || forceScroll) {
          $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
        }
        item.open()
      }, 425)
    } else {
      item.open() // immediately if none is opened
      if (forceScroll) {
        let targetTop = item.offset().top
        targetTop -= $('.header').outerHeight(false) + ($.mlmi.mobile.isMobile ? 18 : 24)
        if (targetTop < $(window).scrollTop() || forceScroll) {
          $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
        }
      }
    }
  }

  return function() {
    item.find('.location-item__form-cta').on('click', item.clicked)
    item.find('.location-item__close').on('click', item.close)
    item.data('location-item', item)
    return item
  }()
}

export default {
  locator: undefined,
  locations: [],
  was_clicked: false,

  init() {
    self = this
    this.attachEvents()
  },

  attachEvents() {
    if ($(MAP_SELECTOR).length || $('.locations-list').length) {
      /* Initialize map when ready */
      if ("MLMI_Locator_Function" in window) {
        $.fn.MLMI_Locator = window.MLMI_Locator_Function
      }
      if ($.fn.MLMI_Locator == undefined) {
        setTimeout(self.attachEvents, 50)
      } else {
        /* Initialize map */
        if ($.mlmi.mobile.isMobile) {
          MAP_OPTIONS.basicOptions.zoom = 9
        }
        if ($(MAP_SELECTOR).length) {
          self.locator = $(MAP_SELECTOR).MLMI_Locator(MAP_OPTIONS)
        } else {
          self.locator = $('<div>').MLMI_Locator(MAP_OPTIONS)
        }

        /* Get locations for filtering */
        if ("locations" in window) {
          self.locations = window.locations
        }

        self.locator.on('search_started', function() {
          $('main').css('min-height', $('main').outerHeight(false) + 'px')
          $('.retailers-list').addClass('loading')
          $('.mobile-retailers').hide()
          $('.location-item, .proximity').remove()
          $('h2 + .text-dark-grey, .mlmi-locator-form, .locator-section--client').fadeOut(250, function() {
            $('.retailers-list, .locator-section--general').fadeIn(450)
            $('main').css('min-height', '')
          })
        })

        self.locator.on('list_loaded', function(event, locator, response) {
          if (response.find('.proximity')) {
            $('p.text-small').after(response.find('.proximity').hide().fadeIn(450))
          }
          $('.mobile-retailers').fadeIn(450)
          $('.retailers-list').removeClass('loading')
          $('.location-item').each(function() {
            $(this).LocationItem().hide().fadeIn(450)
          })

          if (!$.mlmi.mobile.isMobile) {
            gsap.to($('.locator-map'), {
              scrollTrigger: {
                trigger: $('.locator-map'),
                start: () => `top ${$('.header').outerHeight(false) + 32}px`,
                endTrigger: $('.locator-section--general'),
                end: () => `top ${$('.header').outerHeight(false) + 32 + $('.locator-map').height()}px`,
                pin: true,
                scrub: true,
              }
            })
          }
        })

        function markersLoaded() {
          let currentZ = 100
          self.locator.markers.map(function(marker, i) {
            /* Showrooms on top */
            if (marker.location.filters.includes('salle-de-montre')) {
              marker.setOptions({
                zIndex: currentZ++,
              })
            }
            /* Markers rollover */
            google.maps.event.addListener(marker, 'mouseover', function(event) {
              marker.setOptions({
                zIndex: currentZ++,
              })
            })
          })
        }

        $(window).on('markers_loaded', function(event, locator) {
          markersLoaded()
        })
        markersLoaded()

        self.locator.on('marker_clicked', function(event, locator, marker) {
          let $location_item = $('.location-item[data-id="' + marker.location.id + '"]').LocationItem()
          if ($location_item.length) {
            $location_item.clicked(true)
          } else {
            self.was_clicked = true
            $(MAP_OPTIONS.selectors.where).val(marker.location.coords.address)
            $(MAP_OPTIONS.selectors.form).submit()
          }
        })

        $('.js-locator-back').on('click', function() {
          /* Reset map */
          if (self.locator.current.location != undefined) {
            self.locator.current.location.setMap(null)
            self.locator.current.location = undefined
          }
          self.locator.setMarkers(self.locations)

          /* Reset interface */
          if (self.was_clicked) {
            self.was_clicked = false
            $(MAP_OPTIONS.selectors.where).val('')
          }
          $('.retailers-list, .locator-section--general, .locations-none, .mobile-retailers').fadeOut(250, function() {
            $('.locations-none, .proximity').remove()
            $('h2 + .text-dark-grey, .mlmi-locator-form, .locator-section--client').fadeIn(450, function() {
              $('.mobile-retailers__map').css('display', '')
              $('.mobile-retailers__toggle-btn').attr('aria-expanded', 'true')
              const triggers = ScrollTrigger.getAll()
              triggers.forEach(trigger => trigger.kill())
            })
          })
          $('html, body').scrollTo(0, 450, 4)
        })

        $.mlmi.mobile.add(function() {
          $('.mobile-retailers__map').append($('.locator-map'))
          const triggers = ScrollTrigger.getAll()
          triggers.forEach(trigger => trigger.kill())
        }, function() {
          $('#mlmi-locator-data').after($('.locator-map'))
        })

        $('.mobile-retailers__toggle-btn').on('click', function() {
          if ($(this).attr('aria-expanded') === 'true') {
            $(this).attr('aria-expanded', 'false')
            $('.mobile-retailers__map').slideUp('450', 'easeInOutQuart')
          } else {
            $(this).attr('aria-expanded', 'true')
            $('.mobile-retailers__map').slideDown('450', 'easeInOutQuart')
          }
        })

        window.addEventListener('resize orientationchange', () => {
          ScrollTrigger.refresh()
        })
      }
    }
  },
}
